export default __webpack_public_path__ + "static/media/soothe.63a1c06a.png";